import { Pill } from '~/components/pill';
import type { StockTone } from '~/lib/fixtures/demo-products';

const TONE_VARIANT = {
	ok: 'success',
	low: 'warning',
	out: 'danger'
} as const;

interface StockPillProps {
	quantity: number;
	tone: StockTone;
}

/** Stock badge: a coloured dot + the on-hand count (ok ≥ threshold / low / out). */
export function StockPill({ quantity, tone }: StockPillProps) {
	return (
		<Pill variant={TONE_VARIANT[tone]}>
			<span className="inline-block h-1.5 w-1.5 rounded-full bg-current" aria-hidden />
			<span className="tabular-nums">{quantity}</span>
		</Pill>
	);
}
